var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78335 1.625C5.10605 1.625 2.125 4.60605 2.125 8.28335C2.125 11.9606 5.10605 14.9417 8.78335 14.9417C12.4606 14.9417 15.4417 11.9606 15.4417 8.28335C15.4417 4.60605 12.4606 1.625 8.78335 1.625ZM0.875 8.28335C0.875 3.9157 4.4157 0.375 8.78335 0.375C13.151 0.375 16.6917 3.9157 16.6917 8.28335C16.6917 12.651 13.151 16.1917 8.78335 16.1917C4.4157 16.1917 0.875 12.651 0.875 8.28335Z",
    fill: "#34415A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.583 13.0829C13.8271 12.8389 14.2228 12.8389 14.4669 13.0829L16.9419 15.5579C17.186 15.802 17.186 16.1977 16.9419 16.4418C16.6978 16.6859 16.3021 16.6859 16.058 16.4418L13.583 13.9668C13.339 13.7227 13.339 13.327 13.583 13.0829Z",
    fill: "#34415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0c4cbd69e55e2a860d9e6ba6ed90689c.svg";
export { ForwardRef as ReactComponent };